import React from "react";
import { Link } from "react-router-dom";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function googleLogin() {
  const redirectUrl = window.location.origin + "/portal";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#141414]">
      <div className="hidden lg:flex flex-col justify-between bg-black text-white p-12 relative overflow-hidden">
        <div className="absolute inset-0 grid-bg opacity-10" />
        <Link to="/" className="relative flex items-center gap-2 font-display text-xl font-bold">
          <img src="/logo.png" alt="WebLaunch Studio" className="h-9 w-9 rounded-md object-cover ring-1 ring-[#C9A227]/40" /> WebLaunch
        </Link>
        <div className="relative">
          <h2 className="font-display text-4xl font-bold tracking-tight leading-tight">Websites that turn visitors into customers.</h2>
          <p className="mt-4 text-[#7E7663] max-w-md">Manage your project, track progress, request revisions and approve your website — all in one place.</p>
        </div>
        <div className="relative text-[#948C79] text-sm">© {new Date().getFullYear()} WebLaunch Studio</div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-md">
          <Link to="/" className="lg:hidden flex items-center gap-2 font-display text-xl font-bold text-[#F3EDDC] mb-8">
            <img src="/logo.png" alt="WebLaunch Studio" className="h-9 w-9 rounded-md object-cover ring-1 ring-[#C9A227]/40" /> WebLaunch
          </Link>
          <h1 className="font-display text-3xl font-bold tracking-tight text-[#F3EDDC]">{title}</h1>
          <p className="mt-2 text-[#948C79]">{subtitle}</p>
          <div className="mt-8">{children}</div>
          <div className="mt-6 text-center text-sm text-[#948C79]">{footer}</div>
        </div>
      </div>
    </div>
  );
}
